module.exports = new __parcel__URL__("sun.399e38be.svg").toString();